import type { NuxtApp } from '#app';
import type { Router } from 'vue-router';
import LoginCallback from '../callback';

export class Module {
  $nuxt: any;
  $api: any;
  $auth: NuxtApp['$auth'];
  $recaptcha: NuxtApp['$recaptcha'];
  $router: Router;
  callbackHandler: LoginCallback;
  $errorRescue: any;
  $localePath: any;

  constructor(nuxt) {
    this.$nuxt = nuxt;
    this.$api = nuxt.$api;
    this.$auth = nuxt.$auth;
    this.$recaptcha = nuxt.$recaptcha;
    this.$router = nuxt.$router;
    this.callbackHandler = new LoginCallback(nuxt);
    this.$errorRescue = nuxt.$errorRescue;
    this.$localePath = nuxt.$localePath;
  }

  get route() {
    return this.$router.currentRoute.value;
  }

  get tenantSlug() {
    return this.route.params.tenantSlug;
  }

  async validateProvider({ provider, tenantSlug = this.tenantSlug, redirectTo }) {
    return this.$recaptcha.fetchToken(async (token) => {
      const url = await this.$api.$get(`authentication/saml/${tenantSlug}/validate`, {
        query: {
          provider,
          recaptcha_token: token,
          redirect_to: this.$localePath(
            this.callbackHandler.redirectRoute({ redirectTo, withQuery: true }),
          ),
        },
      });

      window.location = url;
    });
  }

  async loginWithProvider({ provider, tenantSlug = this.tenantSlug, redirectTo }) {
    return this.$recaptcha.fetchToken(async (token) => {
      const url = await this.$api.$get(`authentication/saml/${tenantSlug}`, {
        query: {
          provider,
          recaptcha_token: token,
          redirect_to: this.$localePath(
            this.callbackHandler.redirectRoute({ redirectTo, withQuery: true }),
          ),
        },
      });

      window.location = url;
    });
  }

  async sendAccountLinkEmail({ userId, provider }) {
    return this.$recaptcha.fetchToken(async (token) => {
      await this.$api.$post(`authentication/saml/${this.tenantSlug}/account_link_email`, {
        body: {
          user_id: userId,
          provider,
          recaptcha_token: token,
        },
      });
    });
  }

  async handleCallback({ token, redirectTo, errors }) {
    if (token) {
      const { token: exchangedToken } = await this.$api.$post(`authentication/saml/${this.tenantSlug}/exchange_auth_code`, { body: { token } });
      await this.$auth.setUserToken(exchangedToken);
      await this.$auth.fetchUserOnce();
      delete this.route.query.token;
    } else {
      this.$errorRescue(
        this.$nuxt,
        {
          response: {
            _data: {
              errors: errors || ['credentials.invalid_credentials'],
            },
          },
        },
        'invalidToken',
        { silenceRollbar: true },
      );
    }

    return this.callbackHandler.handle({ withQuery: true, redirectTo });
  }
}

export const SetupSaml = (nuxt) => {
  nuxt.$auth.samlModule = new Module(nuxt);
};
